import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import Badge from 'components/base/Badge';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';
import { Signal } from 'data/settings/signals';
import { Link } from 'react-router-dom';

export const signalListTableColumns: ColumnDef<Signal>[] = [
  {
    accessorKey: 'name',
    header: 'Nome da Sinalização',
    cell: ({ row: { original } }) => {
      const { name } = original;
      return (
        <Link to="#!" className="text-decoration-none fw-bold fs-8">
          {name}
        </Link>
      );
    },
    meta: {
      cellProps: { className: 'white-space-nowrap py-4' },
      headerProps: { style: { width: '25%' } }
    }
  },
  {
    accessorKey: 'code',
    header: 'Código',
    meta: {
      cellProps: { className: 'ps-3 fs-9 text-900 white-space-nowrap py-4' },
      headerProps: { style: { width: '10%' }, className: 'ps-3' }
    }
  },
  {
    accessorKey: 'type',
    header: 'Tipo',
    cell: ({ row: { original } }) => {
      const { type } = original;
      const typeColors: Record<string, string> = {
        Advertência: 'warning',
        Proibição: 'danger',
        Obrigação: 'primary',
        Emergência: 'danger',
        Informação: 'info'
      };
      return (
        <Badge
          variant="phoenix"
          bg={typeColors[type] as 'warning' | 'danger' | 'primary' | 'info'}
        >
          {type}
        </Badge>
      );
    },
    meta: {
      cellProps: { className: 'ps-3 py-4' },
      headerProps: { style: { width: '12%' }, className: 'ps-3' }
    }
  },
  {
    accessorKey: 'category',
    header: 'Categoria',
    meta: {
      cellProps: { className: 'ps-3 fs-9 text-900 white-space-nowrap py-4' },
      headerProps: { style: { width: '12%' }, className: 'ps-3' }
    }
  },
  {
    accessorKey: 'priority',
    header: 'Prioridade',
    cell: ({ row: { original } }) => {
      const { priority } = original;
      const priorityColors: Record<string, string> = {
        Baixa: 'success',
        Média: 'warning',
        Alta: 'primary',
        Crítica: 'danger'
      };
      return (
        <Badge
          variant="phoenix"
          bg={
            priorityColors[priority] as
              | 'success'
              | 'warning'
              | 'primary'
              | 'danger'
          }
        >
          {priority}
        </Badge>
      );
    },
    meta: {
      cellProps: { className: 'ps-3 py-4' },
      headerProps: { style: { width: '10%' }, className: 'ps-3' }
    }
  },
  {
    id: 'status',
    header: 'Status',
    accessorFn: ({ status }) => status.label,
    cell: ({ row: { original } }) => {
      const { status } = original;
      return (
        <Badge variant="phoenix" bg={status.type}>
          {status.label}
        </Badge>
      );
    },
    meta: {
      cellProps: { className: 'ps-3 py-4' },
      headerProps: { style: { width: '15%' }, className: 'ps-3' }
    }
  },
  {
    accessorKey: 'location',
    header: 'Localização',
    meta: {
      cellProps: { className: 'ps-3 fs-9 text-900 py-4' },
      headerProps: { style: { width: '15%' }, className: 'ps-3' }
    }
  },
  {
    accessorKey: 'responsible',
    header: 'Responsável',
    meta: {
      cellProps: { className: 'ps-3 fs-9 text-900 white-space-nowrap py-4' },
      headerProps: { style: { width: '12%' }, className: 'ps-3' }
    }
  },
  {
    id: 'action',
    cell: () => (
      <RevealDropdownTrigger>
        <RevealDropdown>
          <ActionDropdownItems />
        </RevealDropdown>
      </RevealDropdownTrigger>
    ),
    meta: {
      headerProps: { style: { width: '8%' }, className: 'text-end' },
      cellProps: { className: 'text-end' }
    }
  }
];

const SignalListTable = () => {
  return (
    <div className="border-bottom">
      <AdvanceTable
        tableProps={{ className: 'phoenix-table border-top border-200 fs-9' }}
      />
      <AdvanceTableFooter pagination className="py-3" />
    </div>
  );
};

export default SignalListTable;
